import React, { useState } from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import AdvancePayment from "./AdvancePayment";
import FinalSettlement from "./FinalSettlement";
import inputStyles from "../../../../styles/Custom/Input.module.css";
import { formatToINR } from "../../../../helpers/utility";
import styles from "./BillingIp.module.css";

const RecordPayment = ({ billData, refreshData }) => {
  const [value, setValue] = useState("advance");
  const activePatient = billData?.data?.admission?.is_active;

  if (activePatient === false) {
    const dischargeDate = billData?.data?.admission?.discharge_date
      ? dayjs(billData.data.admission.discharge_date)
      : null;
    const paymentDetails = billData?.data?.payment_details || {};
    const settledDiscount = Number(paymentDetails?.total_discount || 0);

    return (
      <section className={styles.paymentCard}>
        <div className={styles.paymentFormBody}>
          <label className={styles.formLabel}>Discharge date and time</label>
          <DatePicker
            value={dischargeDate}
            showTime={{ format: "HH:mm" }}
            format="YYYY-MM-DD HH:mm"
            className={inputStyles.mdDateInput}
            style={{ marginBottom: 16 }}
            disabled
            inputReadOnly
            allowClear={false}
          />

          <div className={styles.paymentSummaryList}>
            <div className={styles.paymentSummaryRow}>
              <span>Total charges</span>
              <strong>
                {formatToINR(paymentDetails?.total_amount?.toFixed(2))}
              </strong>
            </div>
            <div className={styles.paymentSummaryRow}>
              <span>Payments</span>
              <strong>
                {formatToINR(paymentDetails?.total_paid_amount?.toFixed(2))}
              </strong>
            </div>
            {settledDiscount > 0 && (
              <div className={styles.paymentSummaryRow}>
                <span>Discount</span>
                <strong>{formatToINR(settledDiscount.toFixed(2))}</strong>
              </div>
            )}
          </div>

          <AdvancePayment
            billData={billData}
            refreshData={refreshData}
            activePatient={activePatient}
          />
        </div>
      </section>
    );
  }

  return (
    <section className={styles.paymentCard}>
      <div className={styles.paymentTabs}>
        <button
          type="button"
          className={`${styles.paymentTab} ${
            value === "advance" ? styles.paymentTabActive : ""
          }`}
          onClick={() => setValue("advance")}
        >
          Record payment
        </button>
        <button
          type="button"
          className={`${styles.paymentTab} ${
            value === "final" ? styles.paymentTabActive : ""
          }`}
          onClick={() => setValue("final")}
        >
          Final settlement
        </button>
      </div>
      <div className={styles.paymentFormBody}>
        {value === "advance" ? (
          <AdvancePayment
            billData={billData}
            refreshData={refreshData}
            activePatient={activePatient}
          />
        ) : (
          <FinalSettlement billData={billData} refreshData={refreshData} />
        )}
      </div>
    </section>
  );
};

export default RecordPayment;
